import styled from 'styled-components/macro';

import CheckboxBase from '@components/common/core/Inputs/Checkbox';

export const Checkbox = styled(CheckboxBase)``;
